import PropTypes from 'prop-types'

export const appFormPropTypes = {
  formik: PropTypes.shape({
    setFieldValue: PropTypes.func.isRequired,
    touched: PropTypes.object,
    validateForm: PropTypes.func.isRequired,
    values: PropTypes.shape({
      currentApp: PropTypes.shape({
        iconUrl: PropTypes.string,
        id: PropTypes.string,
        name: PropTypes.string
      }).isRequired
    })
  })
}
